export const ENGAGEMENTS = [
  {
    slug: 'operating-turnaround',
    title: 'Operating turnaround at scale',
    summary:
      'Led a multi-year transformation that expanded EBITDA and sharpened execution discipline.',
    sector: 'Healthcare',
    companySize: '~$800M',
    duration: '24 mo',
    consultants: 6,
    chips: ['Healthcare', '~$800M', '6 consultants', '24 mo'],
    lede: 'Multi-year operating transformation for a scaled healthcare enterprise under growth and performance pressure.',
    situation:
      'Growth had stalled. Operating discipline and leadership cadence were thin for the scale of the business, and priorities fractured across the top of the house.',
    howForward: [
      'Diagnostic of P&L drivers and operating rhythm',
      'Leadership team reset with clearer decision rights',
      'Execution cadence with owned KPIs and weekly follow-through',
      'Darryl sponsored the engagement; a delivery team embedded with client operations',
    ],
    teamLine: '1 engagement lead · 2 operators · 2 analysts · 1 change lead',
    outcomes: [
      'EBITDA expanded over the engagement window',
      'Clearer top-of-house priorities and follow-through',
      'Operating reviews that stuck after exit',
    ],
  },
  {
    slug: 'healthcare-modernization',
    title: 'Healthcare delivery modernization',
    summary:
      'Guided data-enabled care and operational clarity for decision-makers under real clinical pressure.',
    sector: 'Health system',
    companySize: 'Multi-site',
    duration: '18 mo',
    consultants: 4,
    chips: ['Health system', 'Multi-site', '4 consultants', '18 mo'],
    lede: 'Delivery and data modernization for a multi-site health system facing throughput and decision-latency pressure.',
    situation:
      'Leaders were making high-stakes clinical and operational calls with fragmented data and slow handoffs between sites and central teams.',
    howForward: [
      'Mapped critical care and admin pathways that blocked throughput',
      'Stood up a shared operating view for site and system leaders',
      'Aligned modernization priorities to measurable access and experience goals',
      'Embedded consultants with clinical ops sponsors — not a slide-deck engagement',
    ],
    teamLine: '1 engagement lead · 1 clinical ops specialist · 1 analyst · 1 change lead',
    outcomes: [
      'Faster decision cycles across sites',
      'Clearer ownership of throughput and experience metrics',
      'A practical roadmap the system could keep running after exit',
    ],
  },
  {
    slug: 'leadership-alignment',
    title: 'Leadership alignment under load',
    summary:
      'Brought C-suite teams into shared priorities when complexity was fracturing the top of the house.',
    sector: 'Life sciences',
    companySize: 'C-suite',
    duration: '9 mo',
    consultants: 3,
    chips: ['Life sciences', 'C-suite', '3 consultants', '9 mo'],
    lede: 'C-suite alignment engagement for a life-sciences leadership team under concurrent growth and transformation load.',
    situation:
      'The executive team was working hard in parallel lanes — strategy, ops, and tech — without a shared set of priorities or decision rights.',
    howForward: [
      'Confidential 1:1s and a structured team diagnostic',
      'Facilitated working sessions on priorities and role clarity',
      'Simple operating rhythm for executive decisions and follow-through',
      'Light support bench so Darryl could stay close to the sponsor without overstaffing',
    ],
    teamLine: '1 engagement lead · 1 facilitator · 1 analyst',
    outcomes: [
      'Shared priority set the team could defend externally',
      'Fewer crossed wires between functional leaders',
      'A cadence the C-suite kept after the engagement closed',
    ],
  },
];

export function getEngagement(slug) {
  return ENGAGEMENTS.find((e) => e.slug === slug);
}
